import { render } from "./statisticModel.vue?vue&type=template&id=5b7c2c04&scoped=true"
import script from "./statisticModel.vue?vue&type=script&lang=js"
export * from "./statisticModel.vue?vue&type=script&lang=js"

import "./statisticModel.vue?vue&type=style&index=0&id=5b7c2c04&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7c2c04"]])

export default __exports__